import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const WorkHours = () => {
  const [ref, inView] = useInView({
    triggerOnce: true, // Animation triggers only once
    threshold: 0.2, // Trigger animation when 20% of the component is visible
  });

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  const tableVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.6, delay: 0.4 },
    },
  };

  return (
    <div className="container mx-auto p-6 mb-16">
      {/* Outer Container */}
      <motion.div
        ref={ref}
        className="bg-customAqua600 text-white rounded-xl shadow-lg p-8"
        variants={containerVariants}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
      >
        {/* Inner Container */}
        <div className="space-y-8">
          {/* Title and Description */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
          >
            <h2 className="text-2xl font-bold">Heures de travail</h2>
            <p className="text-lg">
              Découvrez nos horaires d'ouverture pour planifier votre visite.
            </p>
          </motion.div>

          {/* Table of Hours */}
          <motion.div
            className="overflow-x-auto"
            variants={tableVariants}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
          >
            <table className="w-full table-auto border-collapse border border-customAqua100 bg-customAquaa600 text-white rounded-lg">
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">Lundi</td>
                  <td className="border border-gray-300 px-4 py-2">
                    9:00 - 18:00
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">Mardi</td>
                  <td className="border border-gray-300 px-4 py-2">
                    9:00 - 18:00
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">Mercredi</td>
                  <td className="border border-gray-300 px-4 py-2">
                    9:00 - 18:00
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">Jeudi</td>
                  <td className="border border-gray-300 px-4 py-2">
                    9:00 - 18:00
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">Vendredi</td>
                  <td className="border border-gray-300 px-4 py-2">
                    9:00 - 18:00
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">Samedi</td>
                  <td className="border border-gray-300 px-4 py-2">
                    10:00 - 14:00
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">Dimanche</td>
                  <td className="border border-gray-300 px-4 py-2">Fermé</td>
                </tr>
              </tbody>
            </table>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default WorkHours;
